/**
 * Реестр пресетов палитр темы. Значения цветов живут в src/tailwind.css
 * ([data-palette-light="X"] / [data-palette-dark="X"]), здесь — только
 * метаданные для селектора в админке и свотчи превью.
 * '' (пустое имя) — дефолтная палитра Smartep без атрибута.
 */
export interface PalettePreset {
  /** slug: должен совпадать с data-palette-* селектором в tailwind.css */
  name: string;
  label: string;
  mode: 'light' | 'dark';
  /** [фон, карточка, primary] — цвета для свотча в селекторе */
  swatch: [string, string, string];
}

export const LIGHT_PALETTES: PalettePreset[] = [
  {name: '', label: 'Smartep (дефолт)', mode: 'light', swatch: ['#eaf7f4', '#ffffff', '#00c194']},
  {name: 'zinc', label: 'Zinc (shadcn)', mode: 'light', swatch: ['#ffffff', '#ffffff', '#27272a']},
  {name: 'ocean', label: 'Ocean', mode: 'light', swatch: ['#f0f9ff', '#ffffff', '#0284c7']},
  {name: 'forest', label: 'Forest', mode: 'light', swatch: ['#f0fdf4', '#ffffff', '#16a34a']},
  {name: 'violet', label: 'Violet', mode: 'light', swatch: ['#faf7ff', '#ffffff', '#7c3aed']},
  {name: 'sunset', label: 'Sunset', mode: 'light', swatch: ['#fff7ed', '#ffffff', '#ea580c']},
  {name: 'rose', label: 'Rose', mode: 'light', swatch: ['#fff4f5', '#ffffff', '#e11d48']},
  {name: 'coffee', label: 'Coffee', mode: 'light', swatch: ['#f5f0e8', '#fdfaf5', '#92400e']},
];

export const DARK_PALETTES: PalettePreset[] = [
  {name: '', label: 'Smartep dark (дефолт)', mode: 'dark', swatch: ['#1d2021', '#2b2f30', '#4db5da']},
  {name: 'zinc-night', label: 'Zinc night (shadcn)', mode: 'dark', swatch: ['#09090b', '#27272a', '#f4f4f5']},
  {name: 'midnight', label: 'Midnight', mode: 'dark', swatch: ['#0b1220', '#131c30', '#60a5fa']},
  {name: 'nord', label: 'Nord', mode: 'dark', swatch: ['#2e3440', '#3b4252', '#88c0d0']},
  {name: 'dracula', label: 'Dracula', mode: 'dark', swatch: ['#282a36', '#323341', '#bd93f9']},
  {name: 'forest-night', label: 'Forest night', mode: 'dark', swatch: ['#0e1a12', '#16271c', '#4ade80']},
  {name: 'ember', label: 'Ember', mode: 'dark', swatch: ['#1a1210', '#271c17', '#fb923c']},
  {name: 'violet-night', label: 'Violet night', mode: 'dark', swatch: ['#151020', '#1f1830', '#a78bfa']},
];

export const PALETTES: PalettePreset[] = [...LIGHT_PALETTES, ...DARK_PALETTES];

export function isKnownPalette(name: string, mode: 'light' | 'dark'): boolean {
  return PALETTES.some(p => p.mode === mode && p.name === name);
}
